import { render, staticRenderFns } from "./mileage_item_info.vue?vue&type=template&id=4e36fc61&scoped=true"
import script from "./mileage_item_info.vue?vue&type=script&lang=js"
export * from "./mileage_item_info.vue?vue&type=script&lang=js"
import style0 from "./mileage_item_info.vue?vue&type=style&index=0&id=4e36fc61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36fc61",
  null
  
)

export default component.exports